export class LoginCustomerDetails {
    name: string;
    email: string;
    firstName: string;
    lastName: string;
    phoneNo: string;
}